module.exports = __webpack_public_path__ + "img/car_booking.3a59bf7a.png";